
import { PlatformLocation } from '@angular/common';
import { Component, Inject, Optional } from '@angular/core';
import { MatLegacyDialogRef as MatDialogRef, MAT_LEGACY_DIALOG_DATA as MAT_DIALOG_DATA } from '@angular/material/legacy-dialog';
import { CommercialPermitService } from '@max/commercialpermitting/services/commercial-permit.service';
import { BaseComponent } from '@max/shared/base-components/base.component';
import { map } from 'rxjs/operators';

@Component({
    selector: 'commercial-permit-view-modal',
    templateUrl: './commercial-vehicle-permit-modal.html'
})
export class CommercialVehiclePermitModalComponent extends BaseComponent {
    public pageData: any = {};
    public dataLoaded = false;

    constructor(
        public dialogRef: MatDialogRef<CommercialVehiclePermitModalComponent>,
        @Optional() @Inject(MAT_DIALOG_DATA) public commercialVehiclePermitNumberId: number,
        private commercialPermitService: CommercialPermitService
    ){
        super();
    }

    public ngOnInit() {
        this.commercialPermitService.getCommercialPermitDetailById(this.commercialVehiclePermitNumberId).subscribe(result => {
            if (!result) {
                return this.cancel(false);
            }
            this.pageData = result;
            this.dataLoaded = true;
        });
    }

    public cancel(success: boolean) {
        this.dialogRef.close(success);
    }

}
